import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import { ChunkLoadErrorBoundary } from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

import { PPOnboardingModalScreenFallback } from './PPOnboardingModalScreenFallback';

interface LazyPPOnboardingModalScreenProps {
  activeScreen: number;
  onAnimationComplete: () => void;
  onOnboardingComplete: () => void;
}

export const LazyPPOnboardingModalScreen: FunctionComponent<
  LazyPPOnboardingModalScreenProps
> = (props) => {
  const PPOnboardingModalScreen = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "personal-productivity-onboarding-modal-screen" */ './PPOnboardingModalScreen'
      ),
    { namedImport: 'PPOnboardingModalScreen', preload: true },
  );

  return (
    <Suspense fallback={<PPOnboardingModalScreenFallback {...props} />}>
      <ChunkLoadErrorBoundary fallback={null}>
        <PPOnboardingModalScreen {...props} />
      </ChunkLoadErrorBoundary>
    </Suspense>
  );
};
